var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaverSolution5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3309 12.7625C40.6579 9.90208 36.5237 9.90208 34.8508 12.7625C33.6523 14.8117 31.028 15.5149 28.9655 14.3395C26.0864 12.6988 22.5061 14.7658 22.4875 18.0795C22.4741 20.4534 20.553 22.3745 18.1791 22.3879C14.8654 22.4065 12.7984 25.9868 14.4391 28.8658C15.6145 30.9284 14.9113 33.5527 12.8621 34.7512C10.0017 36.4241 10.0017 40.5583 12.8621 42.2313C14.9113 43.4298 15.6145 46.0541 14.4391 48.1166C12.7984 50.9956 14.8654 54.5759 18.1791 54.5945C20.553 54.6079 22.4741 56.529 22.4875 58.9029C22.5061 62.2166 26.0864 64.2837 28.9655 62.6429C31.028 61.4676 33.6523 62.1707 34.8508 64.2199C36.5237 67.0803 40.6579 67.0803 42.3309 64.2199C43.5294 62.1707 46.1537 61.4676 48.2162 62.6429C51.0952 64.2837 54.6755 62.2166 54.6941 58.9029C54.7075 56.529 56.6286 54.6079 59.0025 54.5945C62.3162 54.5759 64.3833 50.9956 62.7425 48.1166C61.5672 46.0541 62.2703 43.4298 64.3195 42.2313C67.18 40.5583 67.18 36.4241 64.3195 34.7512C62.2703 33.5527 61.5672 30.9284 62.7425 28.8658C64.3833 25.9868 62.3162 22.4065 59.0025 22.3879C56.6286 22.3745 54.7075 20.4534 54.6941 18.0795C54.6755 14.7658 51.0952 12.6988 48.2162 14.3395C46.1537 15.5149 43.5294 14.8117 42.3309 12.7625ZM38.7374 54.5912C47.5451 54.5912 54.6852 47.4511 54.6852 38.6433C54.6852 29.8356 47.5451 22.6955 38.7374 22.6955C29.9296 22.6955 22.7895 29.8356 22.7895 38.6433C22.7895 47.4511 29.9296 54.5912 38.7374 54.5912Z",
    fill: "url(#paint0_linear_2137_19461)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3309 12.7625C40.6579 9.90208 36.5237 9.90208 34.8508 12.7625C33.6523 14.8117 31.028 15.5149 28.9655 14.3395C26.0864 12.6988 22.5061 14.7658 22.4875 18.0795C22.4741 20.4534 20.553 22.3745 18.1791 22.3879C14.8654 22.4065 12.7984 25.9868 14.4391 28.8658C15.6145 30.9284 14.9113 33.5527 12.8621 34.7512C10.0017 36.4241 10.0017 40.5583 12.8621 42.2313C14.9113 43.4298 15.6145 46.0541 14.4391 48.1166C12.7984 50.9956 14.8654 54.5759 18.1791 54.5945C20.553 54.6079 22.4741 56.529 22.4875 58.9029C22.5061 62.2166 26.0864 64.2837 28.9655 62.6429C31.028 61.4676 33.6523 62.1707 34.8508 64.2199C36.5237 67.0803 40.6579 67.0803 42.3309 64.2199C43.5294 62.1707 46.1537 61.4676 48.2162 62.6429C51.0952 64.2837 54.6755 62.2166 54.6941 58.9029C54.7075 56.529 56.6286 54.6079 59.0025 54.5945C62.3162 54.5759 64.3833 50.9956 62.7425 48.1166C61.5672 46.0541 62.2703 43.4298 64.3195 42.2313C67.18 40.5583 67.18 36.4241 64.3195 34.7512C62.2703 33.5527 61.5672 30.9284 62.7425 28.8658C64.3833 25.9868 62.3162 22.4065 59.0025 22.3879C56.6286 22.3745 54.7075 20.4534 54.6941 18.0795C54.6755 14.7658 51.0952 12.6988 48.2162 14.3395C46.1537 15.5149 43.5294 14.8117 42.3309 12.7625ZM38.7374 54.5912C47.5451 54.5912 54.6852 47.4511 54.6852 38.6433C54.6852 29.8356 47.5451 22.6955 38.7374 22.6955C29.9296 22.6955 22.7895 29.8356 22.7895 38.6433C22.7895 47.4511 29.9296 54.5912 38.7374 54.5912Z",
    fill: "url(#paint1_linear_2137_19461)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0625 32.8735L28.5661 36.3699C27.3946 37.5415 27.3946 39.441 28.5661 40.6125L32.0625 44.1089",
    stroke: "#535353",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8145 34.4673L39.9939 35.8886L38.3527 38.7311L36.7116 41.5737L35.891 42.9949",
    stroke: "#535353",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1191 32.8735L48.6155 36.3699C49.7871 37.5415 49.7871 39.441 48.6155 40.6125L45.1191 44.1089",
    stroke: "#535353",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_19461",
    x1: 38.5908,
    y1: -8.17914,
    x2: 38.5908,
    y2: 74.7345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C6B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2137_19461",
    x1: 38.5908,
    y1: 10.6172,
    x2: -4.6362,
    y2: 51.2608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2D2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaverSolution5);
export default __webpack_public_path__ + "static/media/naverSolution5.3b7d3854de8979256414bf3c25907c49.svg";
export { ForwardRef as ReactComponent };